export const handleUpdatePriceBeforeVAT = form => {
  const feeSim = Number(form.getFieldValue("fee_sim") || 0)
  const feeConnection = Number(form.getFieldValue("fee_connection") || 0)
  const price = Number(form.getFieldValue("price") || 0)

  const priceBuy = feeSim + feeConnection + price
  form.setFieldsValue({ price_buy: priceBuy })

  const vat = Number(form.getFieldValue("fee_vat") || 0)
  const totalAfterVAT = priceBuy + (priceBuy * vat) / 100
  form.setFieldsValue({ total_after_vat: totalAfterVAT })
}

